import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoadIframeComponent } from '../pages/load-iframe/load-iframe.component';
import { LobbyComponent } from '../pages/lobby/lobby.component';
// import { MarketHistoryComponent } from '../pages/market-history/market-history.component';
// import { RoundHistoryComponent } from '../pages/round-history/round-history.component';
import { WidgetComponent } from '../pages/widget/widget.component';
const routes: Routes = [
  {
    path: 'lobby',
    component: LobbyComponent
  },
  {
    path: 'games',
    component: LoadIframeComponent
  },
  // {
  //   path: 'history',
  //   component: MarketHistoryComponent
  // },
  // {
  //   path: 'round',
  //   component: RoundHistoryComponent
  // },
  {
    path: 'widget',
    component: WidgetComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LauoutRoutingModule { }
